import * as React from 'react';

function SplashScreen() {
    return(
        <div className="splash-container">
            <div className="loading-spinner"></div>
            <p className="loading-text">Loading your data...</p>
            <p className="info-text">Please wait while we set things up for you!</p>
        </div>
    );
}

export default SplashScreen;